import { navigateTo, useRoute } from '#imports'
import { onBeforeMount } from 'vue'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { omit } from '@backmarket/utils/object/omit'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { VALID_GRADES } from '~/scopes/product-core/constants'

/**
 * When the grade in the URL is not valid (i.e., #l=1), the page is broken. We should remove it to fallback on the default one instead.
 *
 * This can happen in various occasions:
 * - Wrong copy paste
 * - Errors during algolia indexation
 */
export function useInvalidGradeFallback() {
  const { grade } = useUrlParams()
  const route = useRoute()
  const logger = useLogger()

  // INC-2609: Grade URL changes MUST be client-only. An SSR redirect here
  // would poison Cloudflare's cache key and aim crawlers at robots.txt-blocked URLs.
  // Using onBeforeMount() to ensure this runs BEFORE useAddGradeInUrl (onMounted).
  onBeforeMount(async () => {
    if (!grade.value || VALID_GRADES.includes(grade.value)) {
      return
    }

    logger.info('[PRODUCT] Invalid grade in the URL', {
      owners: ['bot-squad-product-page-front'],
    })

    const link = {
      ...route,
      type: 'internal',
      query: omit(route.query, ['l']),
      hash: route.hash,
      replace: true,
    }

    await navigateTo(link)
  })
}
